import { render } from "./WorkspaceCard.vue?vue&type=template&id=53c7e8f4&scoped=true"
import script from "./WorkspaceCard.vue?vue&type=script&lang=js"
export * from "./WorkspaceCard.vue?vue&type=script&lang=js"

import "./WorkspaceCard.vue?vue&type=style&index=0&id=53c7e8f4&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c7e8f4"]])

export default __exports__